// @flow
import ContactFormOffre from 'components/contact/ContactFormOffre';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/contact/ContactFormOffre';
import { postContactForm, fetchAllContactForm } from 'actions/formActions';
import { fetchJobFilters } from 'actions/jobActions';

export default withRouter(connect(
  (state: StateType): StateProps => ({
    contactForm: state.formState.contactFormList,
    fetchStatus: state.formState.fetchStatus,
    jobFilters: state.jobListState.jobFilters,
    sendStatus: state.formState.sendStatus
  }),
  (dispatch: DispatchType): DispatchProps => ({
    postContactForm: (formInputs: Object, id: number) => dispatch(postContactForm(formInputs, id)),
    fetchContactForm: () => dispatch(fetchAllContactForm()),
    fetchJobFilters: () => dispatch(fetchJobFilters()),
  })
)(ContactFormOffre));
